module.exports = __webpack_public_path__ + "Flag-659.19a5515caa42bcda49dfb121eb5cfdd6.svg";